import { render, staticRenderFns } from "./msgSet.vue?vue&type=template&id=72f0e40d&"
import script from "./msgSet.vue?vue&type=script&lang=js&"
export * from "./msgSet.vue?vue&type=script&lang=js&"
import style0 from "./msgSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports